/* eslint-disable class-methods-use-this */
const culture = require('./resolvers/culture');
const campaign = require('./resolvers/campaign');
const tenant = require('./resolvers/tenant');
const userAgent = require('./resolvers/userAgent');

class FrontendAudienceProvider {
    constructor(customResolvers = {}) {
        this._customResolvers = customResolvers;
    }

    async getAttributeValues(attributeKeys = undefined) {
        const resolvers = await this._resolveDefaultAttributes()
        const result = {};
        const objPrototype = Object.prototype.toString;
        Object.keys(resolvers)
            .filter(key => !attributeKeys || attributeKeys.includes(key))
            .map(key => ({
                key,
                value: objPrototype.call(resolvers[key]) === '[object Function]' ? resolvers[key]() : resolvers[key]
            }))
            .forEach(attributeValue => {
                if (attributeValue.value !== undefined) {
                    if (objPrototype.call(attributeValue.value) === '[object Object]'
                    && attributeValue.value[attributeValue.key] !== undefined) {
                        result[attributeValue.key] = attributeValue.value[attributeValue.key];
                    } else {
                        result[attributeValue.key] = attributeValue.value;
                    }
                }
            });

        return result;
    }

    async _resolveDefaultAttributes() {
        let result = Object.assign({
            utm_id: campaign.getAttribute(),
            culture: culture.getAttribute(),
            browserId: userAgent.getAttributes(),
            device: userAgent.getAttributes(),
            tenant: tenant.getAttribute()
        }, this._customResolvers);
        return result;
    };
}

module.exports = FrontendAudienceProvider;
